export const CATEGORY_COUNT_PER_PAGE = 10;

export const INVALID_CATEGORY_ID = 0;

export const PAGE_COUNT_PER_PAGE = 5;

export const PREVIEW_ICON_COUNT_ON_PAGE = 3;

export const PREVIEW_ICON_SIZE = 55;

export const TEMPLATE_COUNT_PER_PAGE = 9;

export const TemplateType = {
  COMMON: 0,
  CUSTOM: 1,
  DEFAULT: 2,
  BLANK: 3,
};

export const BlankTemplate = {
  categoryId: 0,
  designId: 0,
  designKeywords: '',
  designTitle: 'Blank',
  folderId: 0,
  isSelected: false,
  templateId: 0,
  templateType: TemplateType.BLANK,
};

export const backgroundStep = {
  Init: 0,
  Recent: 1,
};

export const BackgroundDisplayingEnum = {
  Options: 0,
  Recent: 1,
  Search: 2,
};
